import i18n from "shared/i18n";

const validate = (values) => {
  const errors = {};

  if (!values.country_id) {
    errors.country_id = i18n.t("Please, select your country");
  }

  return errors;
};

export default validate;
